import type { PendingRosterOp } from './pendingRosterOps'
import type { KingdomTechEffects } from '../../../constants/kingdom/kingdomTechEffects'
import { DEFAULT_KINGDOM_TECH_EFFECTS } from '../../../constants/kingdom/kingdomTechEffects'

export interface BuildingStatus {
  wall: {
    level: number
    hp: number
    maxHp: number
    effectiveHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  },
  hunting: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  },
  bank: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
    repairCooldown?: Date | null
  }
  support: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
    repairCooldown?: Date | null
  },
  well_1: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  well_2: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  tower: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  hospital: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
    repairCooldown?: Date | null
  }
  training: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  bakery: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  bakery_2: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  woodHouse: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  wheatFarm: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  stoneFactory: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  },
  kingdom: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  ironMine: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  ironMine_2: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  blacksmith: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
  }
  boostingTree?: {
    level: number
    hp: number
    maxHp: number
    isLocked?: boolean
    characters?: any[] | null
    upgradeCooldown?: Date | null
    /** Server-resolved cooldown end (alliance + kingdom-tech reductions applied). Authoritative. */
    upgradeCooldownEndsAt?: Date | string | null
    repairCooldown?: Date | null
  }
}

export interface RepairRequirements {
  ecsToken: number
  gem: number
  iron?: number
  stone: number
  wood: number
  repairTime?: number // Repair time in seconds
  repairCooldown?: Date | null // Current repair cooldown timestamp
}

export interface AllMiningStatus {
  well1?: {
    isStartMining: boolean
    isCompletedMining: boolean
  }
  well2?: {
    isStartMining: boolean
    isCompletedMining: boolean
  }
  tower?: {
    isStartMining: boolean
    isCompletedMining: boolean
  }
  hunting?: {
    isStartMining: boolean
    isCompletedMining: boolean
  }
  training?: {
    isStartMining: boolean
    isCompletedMining: boolean
  }
  bakery?: {
    isStartMining: boolean
    isCompletedMining: boolean
  }
  bakery2?: {
    isStartMining: boolean
    isCompletedMining: boolean
  }
  woodHouse?: {
    isStartMining: boolean
    isCompletedMining: boolean
  }
  stoneFactory?: {
    isStartMining: boolean
    isCompletedMining: boolean
  }
  ironMine?: {
    isStartMining: boolean
    isCompletedMining: boolean
  }
  ironMine2?: {
    isStartMining: boolean
    isCompletedMining: boolean
  }
  blacksmith?: {
    isCrafting: boolean
    isCompleted: boolean
    craft?: {
      weaponId: string
      weaponName: string
      weaponType: string
      timeRemaining: number
      isCompleted: boolean
    }
  }
  [key: string]: any
}

export interface BuildingProgress {
  current: number
  required: number
  met: boolean
}

export interface EmpirePeriod {
  id: number
  name: string
}

export interface EmpirePeriodInfo {
  currentPeriod: EmpirePeriod
  nextPeriod: EmpirePeriod | null
  totalLevel: number
  progress: number
  requirementsMet: boolean
  buildingProgress: {
    wheatFarm: BuildingProgress
    bakery: BuildingProgress
    well: BuildingProgress
    rockCrusher: BuildingProgress
    sawmill: BuildingProgress
    tower: BuildingProgress
    support: BuildingProgress
    training: BuildingProgress
    hospital: BuildingProgress
    bank: BuildingProgress
    hunting: BuildingProgress
    wall?: BuildingProgress
    blacksmith?: BuildingProgress
    ironMine?: BuildingProgress
  }
  kingdomPeriod: {
    currentPeriod: number
    totalEmpireLevel: number
    lastUpdated: string
  } | null
  palaceLevel?: number
  spyTechLevel?: number
  techCompleted?: boolean
  buildingsReady?: boolean
}

export interface LandState {
  buildingStatus: BuildingStatus
  castleBuildingStatus: { [castleId: number]: BuildingStatus } // Separate state for each castle
  isLoading: boolean
  isImmediate: boolean
  error?: string
  isRestored: boolean
  repairRequirements: RepairRequirements
  supportCharacters: any[]
  isSetSupportCharacterSuccess: boolean
  supportState: boolean
  upgradeRequirements: {
    ecsToken: number,
  },
  upgradeAvailable: boolean
  allMiningStatus: AllMiningStatus
  /** Un-acknowledged roster intent, replayed over server state at render (see `pendingRosterOps`). */
  pendingRosterOps: PendingRosterOp[]
  empirePeriod: EmpirePeriodInfo | null
  /** From `/land/buiding/status` — kingdom tree unlocks for UI (mining, marketplace, etc.). */
  kingdomTechEffects: KingdomTechEffects
}

export const initialLandState: LandState = {
  buildingStatus: {
    wall: {
      level: 0,
      hp: 0,
      maxHp: 100,
      effectiveHp: 0,
      characters: null
    },
    hunting: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: []
    },
    bank: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    },
    support: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: []
    },
    well_1: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: []
    },
    well_2: {
      level: 0,
      hp: 0,
      maxHp: 0,
      characters: []
    },
    tower: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: []
    },
    hospital: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    },
    training: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    },
    bakery: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    },
    bakery_2: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    },
    woodHouse: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    },
    wheatFarm: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    },
    stoneFactory: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    },
    ironMine: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    },
    ironMine_2: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    },
    blacksmith: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    },
    kingdom: {
      level: 0,
      hp: 0,
      maxHp: 100,
      characters: null
    }
  },
  isLoading: false,
  isImmediate: false,
  error: undefined,
  isRestored: false,
  repairRequirements: {
    ecsToken: 0,
    gem: 0,
    iron: 0,
    stone: 0,
    wood: 0,
    repairTime: 0,
    repairCooldown: null,
  },
  supportCharacters: [],
  isSetSupportCharacterSuccess: false,
  supportState: false,
  upgradeRequirements: {
    ecsToken: 0,
  },
  upgradeAvailable: false,
  allMiningStatus: {},
  pendingRosterOps: [],
  castleBuildingStatus: {}, // Initialize empty object for castle building status
  empirePeriod: null,
  kingdomTechEffects: DEFAULT_KINGDOM_TECH_EFFECTS,
}
